import React from 'react';
import { Link } from 'react-router-dom';
import { formatMoney, productStateLabel } from './mobileProductUtils';
import MobileProductThumbnail from './MobileProductThumbnail';
import MobileProductMenu from './MobileProductMenu';
import ProductQuantity from '../ProductQuantity';

export default function MobileProductCard({
  product,
  selected,
  onSelect,
  onEdit,
  onReceipt,
  onHistory,
  onDeactivate,
}) {
  return (
    <article className={`card mp-card${selected ? ' mp-card-selected' : ''}`} data-admin-product-id={product.id}>
      <div className='card-header mp-card-top'>
        <label className='mp-select-product'>
          <input
            type='checkbox'
            checked={selected}
            onChange={() => onSelect(product.id)}
            aria-label={`Обрати товар ${product.id}`}
          />
          <span>#{product.id}</span>
        </label>
        <div className='mp-card-status'>
          <span className={`mp-state mp-state-${product.state}`}>
            {productStateLabel(product.state)}
          </span>
          <MobileProductMenu label={`Дії з товаром ${product.id}`}>
            <button type='button' className='dropdown-item' onClick={() => onHistory(product)}>
              <i className='bi bi-clock-history mr-2' aria-hidden='true' />
              Історія залишків
            </button>
            <button
              type='button'
              className='dropdown-item text-danger'
              onClick={() => onDeactivate(product)}
            >
              <i className='bi bi-trash mr-2' aria-hidden='true' />
              Деактивувати
            </button>
          </MobileProductMenu>
        </div>
      </div>
      <div className='card-body mp-card-body'>
        <MobileProductThumbnail product={product} />
        <div className='mp-card-info'>
          <h2>
            <Link to={`/product/${product.id}`} title={product.name}>
              {product.name}
            </Link>
          </h2>
          <p className='mp-product-code'>{product.code || product.productCode || 'Без артикулу'}</p>
          <div className='mp-card-values'>
            <strong>{formatMoney(product.price)}</strong>
            <ProductQuantity product={product} showUnits
              className={Number(product.quantity ?? 0) <= 0 ? 'mp-stock-empty' : 'mp-stock'} />
          </div>
          {product.expectedArrivalDate && (
            <p className='mp-arrival'>
              Очікується:{' '}
              {Array.isArray(product.expectedArrivalDate)
                ? product.expectedArrivalDate
                    .slice(0, 3)
                    .reverse()
                    .join('.')
                : String(product.expectedArrivalDate).split('T')[0]}
            </p>
          )}
        </div>
      </div>
      <div className='mp-card-actions'>
        <button type='button' className='btn btn-sm btn-light' onClick={() => onEdit(product)}>
          <i className='bi bi-pencil mr-1' aria-hidden='true' />
          Редагувати
        </button>
        <button type='button' className='btn btn-sm btn-light' onClick={() => onReceipt(product)}>
          <i className='bi bi-box-seam mr-1' aria-hidden='true' />
          Надходження
        </button>
        <button
          type='button'
          className='btn btn-sm btn-light mp-history-button'
          onClick={() => onHistory(product)}
          aria-label='Історія залишків'
          title='Історія залишків'
        >
          <i className='bi bi-clock-history' aria-hidden='true' />
        </button>
      </div>
    </article>
  );
}
